import { render, staticRenderFns } from "./SalesReports.vue?vue&type=template&id=0d92b167"
import script from "./SalesReports.vue?vue&type=script&lang=js"
export * from "./SalesReports.vue?vue&type=script&lang=js"
import style0 from "./SalesReports.vue?vue&type=style&index=0&id=0d92b167&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports